import React from 'react';
import './Header.css';

const Header = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <header className="sticky-header">
            <div className="logo-container" onClick={scrollToTop}>
                <img src="/logo_kotto.png" alt="KOTTO Logo" className="header-logo" />
            </div>
        </header>
    );
};

export default Header;
